export const cardImageUrl = 'https://assets.homedepot-static.com/p/static/images/icons/thd-consumer-creditcard.svg';
